import { memo, type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => {

  const {width = 29, height = 29} = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${width} ${height}`} fill="none" {...props}>
      <path
        fill="currentColor"
        d="M21.054 10.537c.226.213.339.484.339.813 0 .33-.113.6-.34.813l-5.667 5.345a1.097 1.097 0 0 1-.4.247 1.45 1.45 0 0 1-.94-.015 1.14 1.14 0 0 1-.385-.232l-5.668-5.345a1.07 1.07 0 0 1-.338-.813c0-.33.113-.6.338-.813.226-.213.514-.32.863-.32s.636.107.862.32l4.806 4.53 4.805-4.53c.226-.213.513-.32.862-.32.35 0 .637.107.863.32Z"
      />
    </svg>
  );
};
const Memo = memo(SvgComponent);
export { Memo as Chevron };
